<template>
  <div class="template-html-builder" :class="{ [extraClass]: true }">
    <div class="template-html-builder__header">
      <div class="title">
        <span class="label">HTML</span
        ><span v-if="this.type === 'postcard'" class="subLabel"
          >{{ this.currentSide }} side</span
        >
      </div>
      <VSwitcher
        v-if="this.type === 'postcard'"
        type="single"
        :switcherKeys="switcherKeys"
        @change="key => changeSide(key)"
      ></VSwitcher>
    </div>

    <!--for postcards-->
    <VForm
      v-show="(this.type === 'postcard') & (this.currentSide === 'front')"
      :name="postcardFormName"
      :fields="postcardFrontHtmlField"
      @change="onChangeHtmlSave"
      @blur="onBlurHtmlSave"
      extraClass="postcard-builder-form"
    ></VForm>
    <VForm
      v-show="(this.type === 'postcard') & (this.currentSide === 'back')"
      :name="postcardFormName"
      :fields="postcardBackHtmlField"
      @change="onChangeHtmlSave"
      @blur="onBlurHtmlSave"
      extraClass="postcard-builder-form"
    ></VForm>

    <!--For letters-->
    <VForm
      v-if="this.type === 'letter'"
      :name="letterFormName"
      :fields="letterHtmlField"
      @change="onChangeHtmlSave"
      @blur="onBlurHtmlSave"
      extraClass="letters-builder-form"
    ></VForm>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import Prism from "prismjs";

import VForm from "@/components/VForm";
import VPrismCode from "@/components/VPrismCode";
import withFormUtils from "@/mixins/withFormUtils";
import VSwitcher from "@/components/VSwitcher";

// assets
import switchIcon from "@/assets/images/switch-circle.svg";
import switchIconActive from "@/assets/images/switch-circle-active.svg";

export default Vue.component("TemplateHtmlBuilder", {
  props: {
    // template: VueTypes.object
    type: VueTypes.oneOf(["postcard", "letter"]).def("postcard"),
    extraClass: VueTypes.string
  },

  components: {
    VForm,
    VPrismCode,
    VSwitcher
  },

  mixins: [withFormUtils],

  data() {
    return {
      switchIcon,
      currentSide: "front",
      postcardFormName: "postcardTemplateSettings",
      letterFormName: "lettersBuilder",
      timerHtmlSave: 0
    };
  },

  computed: {
    postcardFrontHtmlField() {
      return [
        {
          elementType: "code",
          name: "front_html"
        }
      ];
    },
    postcardBackHtmlField() {
      return [
        {
          elementType: "code",
          name: "back_html"
        }
      ];
    },

    letterHtmlField() {
      return [
        {
          elementType: "code",
          name: "html"
        }
      ];
    },

    switcherKeys() {
      return {
        key: this.currentSide,
        label:
          this.currentSide === "front" ? "Switch to Back" : "Switch to Front",
        icon: switchIcon,
        iconActive: switchIconActive
      };
    }
  },

  methods: {
    changeSide(key) {
      const changedSide =
        key === "front"
          ? (this.currentSide = "back")
          : (this.currentSide = "front");
      this.$emit("changeSide", changedSide);

      return changedSide;
    },

    onChangeHtmlSave(command) {
      clearTimeout(this.timerHtmlSave);
      if (command !== "stop") {
        this.timerHtmlSave = setTimeout(() => this.$emit("saveHtml"), 3000);
      }
    },

    onBlurHtmlSave() {
      this.onChangeHtmlSave("stop");
      this.$emit("saveHtml");
    }
  },

  created() {
    setTimeout(() => Prism.highlightAll(), 0);

    // if (
    //   this.template &&
    //   (this.template.front_html || this.template.back_html)
    // ) {
    //   this.initializeForm({
    //     formName: this.name,
    //     fields: {
    //       front_html: this.template.front_html,
    //       back_html: this.template.back_html
    //     }
    //   });
    // }
  }

  // watch: {
  //   template() {
  //     if (
  //       this.template &&
  //       (this.template.front_html || this.template.back_html)
  //     ) {
  //       this.initializeForm({
  //         formName: this.name,
  //         fields: {
  //           front_html: this.template.front_html,
  //           back_html: this.template.back_html
  //         }
  //       });
  //     }
  //   }
  // }
});
</script>

<style lang="scss" scoped>
$ns: "template-html-builder";

.#{$ns} {
  display: grid;
  grid-template-rows: 34px auto;
  width: 100%;
  &/deep/ form {
    pre {
      min-width: auto;
    }
  }
}

.#{$ns}__header {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;

  .title {
    display: flex;
    align-items: center;

    .subLabel {
      color: $primary-color;
      text-transform: capitalize;
    }
  }
}

/*Media*/
</style>
